import type { SegmentTrackMainNavMenuClickEvent } from "@beautypie/segment/Track/MainNavMenuClick"
import { track, trackClick as trackNavClick } from "tracking"
import { trackClickEvent } from "utils/gtm"
import type { ClickValueType } from "utils/gtm/types"

export const trackClick = (label: ClickValueType, text: string): void => {
  const { href } = window.location

  if (label === "Search Menu Item Clicked") {
    track({
      event: "Page Element Clicked",
      properties: {
        module_content: "Search",
        location_type: "Input",
      },
    })
    return
  }

  trackNavClick({
    event: "Main Nav Menu Click",
    properties: {
      menu_category: label,
      click_text: text,
      click_url: href,
    },
  } as SegmentTrackMainNavMenuClickEvent)

  trackClickEvent({
    event: "Click",
    value: "Nav Click",
    label,
    clickText: text,
    clickUrl: href,
  })
}
